import { render, staticRenderFns } from "./ResponsiveRatingStars.vue?vue&type=template&id=2dd8a479&scoped=true"
import script from "./ResponsiveRatingStars.vue?vue&type=script&lang=js"
export * from "./ResponsiveRatingStars.vue?vue&type=script&lang=js"
import style0 from "./ResponsiveRatingStars.vue?vue&type=style&index=0&id=2dd8a479&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd8a479",
  null
  
)

export default component.exports